export default "__VITE_ASSET__Cik6d0tJ__"